import { render, staticRenderFns } from "./SystemMessageManagementPanel.vue?vue&type=template&id=6b6980c2&scoped=true"
import script from "./SystemMessageManagementPanel.vue?vue&type=script&lang=js"
export * from "./SystemMessageManagementPanel.vue?vue&type=script&lang=js"
import style0 from "./SystemMessageManagementPanel.vue?vue&type=style&index=0&id=6b6980c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6980c2",
  null
  
)

export default component.exports